import React, { FunctionComponent } from "react";
import { i18n } from "../lang/i18n";
import { translation } from "../lang/translation";

export const NotFound: FunctionComponent = () => <div>{i18n.t(translation.notFound)}</div>;
